import { LitElement, css, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';

import * as TagNames from './form.tagnames';
import { getGlobalStyleSheets } from '../../global-styles';

@customElement(TagNames.FormInputMaxLengthCounter)
export class AtlInputTextMaxLength extends LitElement {
   @state()
   private _maxLength: number = 0;

   @state()
   private _currentLength: number = 0;

   private _inputElement?: HTMLInputElement | HTMLTextAreaElement;

   static styles = [
      ...getGlobalStyleSheets(),
      css`
         :host {
            display: block;
         }
      `,
   ];

   disconnectedCallback(): void {
      this._inputElement?.classList.remove('form-input-text-max-length');
      this._inputElement?.removeEventListener('input', this.updateCount);
      super.disconnectedCallback();
   }

   render() {
      return html`
         <slot @slotchange=${this._onSlotChange}></slot>
         <div class="d-flex justify-content-between">
            <slot name="inline-content"></slot>
            <div part="counter" class="form-text">
               (${this._currentLength}/${this._maxLength} max)
            </div>
         </div>
      `;
   }

   private _onSlotChange = () => {
      const slot = this.shadowRoot!.querySelector('slot')!;
      const nodes = slot.assignedElements({ flatten: true });

      const input = nodes.find(
         (n) =>
            n instanceof HTMLInputElement || n instanceof HTMLTextAreaElement
      ) as HTMLInputElement | HTMLTextAreaElement | undefined;

      if (input && input !== this._inputElement) {
         this._inputElement?.classList.remove('form-input-text-max-length');
         this._inputElement?.removeEventListener('input', this.updateCount);

         this._inputElement = input;
         this._maxLength = Number(input.maxLength) || 0;
         this._currentLength = input.value?.length ?? 0;

         input.classList.add('form-input-text-max-length');
         input.addEventListener('input', this.updateCount);
      }
   };

   private updateCount = () => {
      this._currentLength = this._inputElement?.value?.length ?? 0;
   };
}
